import React, { useState, useCallback, useEffect, useRef } from "react";
import axios from "axios";
import { AutoComplete, Button, Form, Input, Select, Spin } from "antd";
import { useHistory } from "react-router";
import { authenticateToken } from "../../utils/auth";
import { debounce } from "lodash";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  Polygon,
  InfoWindow,
} from "@react-google-maps/api";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import { DrawingManager } from "@react-google-maps/api";
//import { DrawingManager } from "react-google-maps/lib/components/drawing/DrawingManager";
import "@reach/combobox/styles.css";
import {
  getParamValue,
  checkStatesAndPushToHistory,
  jcTypeArray,
} from "../../utils/index";
import usePrevious from "../../hooks/PreviousState";
import { useLocation } from "react-router-dom";
import ShopMarker from "../../images/icon/ShopMarker.svg";
// import mapStyles from "./mapStyles";

const libraries = ["geometry,drawing,places"];
const mapContainerStyle = {
  height: "80vh",
  width: "80vw",
};
const options = {
  // styles: mapStyles,
  disableDefaultUI: true,
  zoomControl: true,
};
const center = {
  lat: 23.773414356724892,
  lng: 90.41340705259854,
};
const PolygonMap = (props) => {
  const onLoad = (drawingManager) => {};
  const history = useHistory();
  const router = useLocation();
  // show all polygon
  const [key, setKey] = useState("");
  const [type, setType] = useState(
    getParamValue(router.search, "type") || "JC_MART"
  );

  const [limit, setLimit] = useState(16);
  const previousType = usePrevious(type);
  const previousKey = usePrevious(key);
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [allNeighborhood, setAllNeighborhood] = useState({
    loading: false,
    data: null,
  });

  const [allShops, setAllShops] = useState({
    loading: false,
    data: null,
  });
  const [form] = Form.useForm();

  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberNeighborhoodList")
    );

    if (retrievedObject.key) setKey(retrievedObject.key);
    if (retrievedObject.type) setType(retrievedObject.type);
  }
  const getNeighborhood = useCallback(async () => {
    let pageReseted = false;
    if (localStorage.getItem("rememberNeighborhoodList") != null) {
      checkLocalStorageAndSetParams();
      localStorage.removeItem("rememberNeighborhoodList");
    } else {
      pageReseted = checkStatesAndPushToHistory(
        [previousKey, previousType],
        [key, type],
        ["key", "type"],
        history
      );
    }
    setAllNeighborhood({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/neighborhood/all` +
          (type ? `?type=${type}` : ``) +
          (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
          (limit ? `&limit=${limit}` : ``) +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setAllNeighborhood({ loading: false, data: res.data });
      })
      .catch((err) => {
        setAllNeighborhood({ loading: false, data: [] });
      });
  }, [limit, page, type, key]);

  const getAllShopList = useCallback(async () => {
    let pageReseted = false;
    if (localStorage.getItem("rememberShopList") != null) {
      checkLocalStorageAndSetParams();
      localStorage.removeItem("rememberShopList");
    } else {
      pageReseted = checkStatesAndPushToHistory(
        [previousKey, previousType],
        [key, type],
        ["key", "type"],
        history
      );
    }
    setAllShops({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/shop` +
          (type ? `?type=${type}` : ``) +
          (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
          (limit ? `&limit=${limit}` : ``) +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setAllShops({ loading: false, data: res.data });
      })
      .catch((err) => {
        setAllShops({ loading: false, data: [] });
      });
  }, [limit, page, type, key]);

  useEffect(() => {
    getNeighborhood();
  }, [getNeighborhood]);
  useEffect(() => {
    getAllShopList();
  }, [getAllShopList]);

  //show all polygon end

  // const onPolygonComplete = (polygon) => {
  //   console.log("polygoncomplete value", polygon);
  // };

  function getPaths(polygon) {
    var polygonBounds = polygon.getPath();
    var bounds = [];
    for (var i = 0; i < polygonBounds.length; i++) {
      var point = {
        latitude: polygonBounds.getAt(i).lat(),
        longitude: polygonBounds.getAt(i).lng(),
      };
      bounds.push(point);
    }
    return bounds;
    // console.log("polygon all data ::", bounds);
  }

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyDL9J82iDhcUWdQiuIvBYa0t5asrtz3Swk",
    libraries,
  });
  const [markers, setMarkers] = React.useState([]);

  const onMapClick = React.useCallback((e) => {
    setMarkers((current) => [
      // ...current,
      {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
        time: new Date(),
      },
    ]);
  }, []);
  const google = window.google;
  const mapRef = React.useRef();
  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
  }, []);

  const panTo = React.useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(14);
    setMarkers((current) => [
      // ...current,
      {
        lat,
        lng,
        time: new Date(),
      },
    ]);
  }, []);

  if (loadError) return "Error";
  if (!isLoaded) return "Loading...";

  return (
    <div>
      <div className="d-flex w-full justify-content-between  pr-3">
        <Form.Item
          hasFeedback
          label="Neighborhood Name"
          rules={[
            {
              required: true,
              message: "Neighborhood Name is Required!",
            },
          ]}
          name="name"
        >
          <Input id="name" type="text" placeholder="Enter Neighborhood Name" />
        </Form.Item>
        <Form.Item
          hasFeedback
          label="Type"
          rules={[
            {
              required: true,
              message: "Type is required!",
            },
          ]}
          name="type"
        >
          <Select
            placeholder="Shop Type"
            style={{ minWidth: 250 }}
            onChange={(val) => setType(val)}
          >
            {Object.values(jcTypeArray)?.map((type, i) => (
              <Select.Option value={type} key={i}>
                {type.replace("_", " ")}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>

      <Search panTo={panTo} />

      <GoogleMap
        id="map"
        mapContainerStyle={mapContainerStyle}
        zoom={12}
        center={center}
        options={options}
        onClick={onMapClick}
        onLoad={onMapLoad}
        options={{ scrollwheel: false }}
      >
        <DrawingManager
          drawingMode={"polygon"}
          //onPolygonComplete={onPolygonComplete}
          onPolygonComplete={(value) => {
            props.sendPoints(getPaths(value));
          }}
          options={{
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_RIGHT,
              drawingModes: [google.maps.drawing.OverlayType.POLYGON],
            },
            polygonOptions: { editable: true },
          }}
          //  onPolygonComplete={(value) => console.log(getPaths(value))}
        />

        {allNeighborhood?.data?.neighborhoods?.map((neighborhood) => (
          <Polygon
            path={neighborhood?.polygon?.points?.map((point) => ({
              lat: point?.y,
              lng: point?.x,
            }))}
            options={{
              strokeColor: "red",
              strokeOpacity: 0.75,
              strokeWeight: 2,
              fillColor: "rgb(185 153 255 / 44%)",
              fillOpacity: 0.6,
              icons: [
                {
                  offset: "0",
                  repeat: "20px",
                },
              ],
            }}
          />
        ))}
        {allShops?.data?.shops?.map((shop) => (
          <Marker
            icon={ShopMarker}
            title={shop?.name}
            position={{
              lat: shop?.location?.y,
              lng: shop?.location?.x,
            }}
          ></Marker>
        ))}
        {markers.map((marker) => (
          <Marker
            key={`${marker.lat}-${marker.lng}`}
            position={{ lat: marker.lat, lng: marker.lng }}
          />
        ))}
      </GoogleMap>
    </div>
  );
};
export default PolygonMap;

function Search({ panTo }) {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      location: { lat: () => 23.773414356724892, lng: () => 90.41340705259854 },
      radius: 100 * 1000,
    },
  });

  // https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletionRequest

  const handleInput = (e) => {
    setValue(e.target.value);
  };

  const handleSelect = async (address) => {
    setValue(address, false);
    clearSuggestions();

    try {
      const results = await getGeocode({ address });
      const { lat, lng } = await getLatLng(results[0]);
      panTo({ lat, lng });
    } catch (error) {
      console.log("😱 Error: ", error);
    }
  };

  return (
    <div className="search">
      <Combobox onSelect={handleSelect}>
        <ComboboxInput
          value={value}
          onChange={handleInput}
          disabled={!ready}
          placeholder="Search your location"
        />
        <ComboboxPopover>
          <ComboboxList>
            {status === "OK" &&
              data.map(({ id, description }) => (
                <ComboboxOption key={id} value={description} />
              ))}
          </ComboboxList>
        </ComboboxPopover>
      </Combobox>
    </div>
  );
}
